<template>
    <loadingScreen :shopData="shopData" v-if="isLoading" />
    <div class="mainBody" v-else>
        <router-view
            @getShopProducts="getShopProducts"
            @getShippingProfile="getShippingProfile"
            @fetchData="fetchData"
            
            :shopData="shopData"    
            :shopProducts="shopProducts"
            :shippingProfile="shippingProfile"
            :shopDealsMetadata="shopDealsMetadata"
            :idShop="idShop"    
        />
        <Toast />
        <ConfirmDialog></ConfirmDialog>
        <headerMenu />
    </div>
</template>

<script>
import userShop from '@/apiFetches(old)/userShop'

import ConfirmDialog from 'primevue/confirmdialog';

import Toast from 'primevue/toast';
import core from './api/index'

import loadingScreen from './components/loadingScreen.vue'
import headerMenu from './components/headerMenu.vue'

export default {
    name: 'App',
    components: {
        ConfirmDialog,
        Toast,
        loadingScreen,
        headerMenu
    },
    computed: {
        isAuthenticated() {
            return this.$route.meta.isAuthenticated;
        }
    },
    watch: {
        isAuthenticated: {
            handler(newVal) {
                if (newVal) {
                    this.getShopProducts()
                    this.getShippingProfile()
                    this.getShopDealsMetadata()
                }
            },
            immediate: true, // Executes the watcher immediately on component creation
            deep: true // Watches the nested properties if needed
        },
        // Watch for route changes
        $route(to, from) {
            if (from.path === '/login' && to.path === '/') {
                this.showLoadingScreen();
            }
        },
    },
    data() {
        return {
            isLoading: false,

            idShop: 41,
            shopData: null,
            shopProducts: null,
            shippingProfile: null,
            shopDealsMetadata: null
        }
    },
    methods: {
        fetchData() {
            this.getShopData()
            this.getShopProducts()
            this.getShippingProfile()
            this.getShopDealsMetadata()
        },

        showLoadingScreen() {
            this.isLoading = true

            setTimeout(() => {
                this.isLoading = false;  
            }, 5000)
        },

        getShopData: async function() {
            userShop(this.idShop)
                .then((res) => {
                    this.shopData = res.data.shop
                })
        },

        getShopProducts() {
            fetch(this.$fetchIp+'/v2/listing/shop/'+this.idShop+'?limiter=100', {
                method: 'GET',
                headers: {
                    'Content-type':'application/json',
                    'Authorization': 'salaTokken'
                },
                credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.data.listings) {
                    this.shopProducts = res.data.listings
                    this.shopProducts.reverse()
                } else {
                    this.shopProducts = []
                }
            })
        },

        getShippingProfile() {
            fetch(this.$fetchIp+'/v2/shipping/profile/'+this.idShop, {
                method: 'GET',
                headers: {
                    'Content-type':'application/json'
                },
                credentials: 'include',
            })
            .then((res) => res.json()) 
            .then((res) => {
                this.shippingProfile = res.data.shippingProfile
            })
        },

        getShopDealsMetadata() {
            core.dealApi.getShopDeals({
                pathParam: this.idShop,
                queryParams: {
                    metadata: true
                }
            })
            .then(res => {
                if(res.data.deals) {
                    this.shopDealsMetadata = res.data.deals.metadata
                }
            })
        },

        getShopReferrals() {
            fetch(this.$fetchIp+'/v2/referral/shop/'+this.idShop+'?idResource=listing', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.status == 'success') {
                    if(res.data.shopReferrals) {
                        const shopReferrals = res.data.shopReferrals[0]
                        console.log(shopReferrals)
                        // this.referralArr = Object.entries(this.shopReferrals.counters)
                    }
                }
            })
        }
    },

    created() {
        this.getShopData()
        this.getShopReferrals()
    },
    // updated() {
    //     this.getShopProducts()
    // }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lora&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Palanquin+Dark&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Baloo+2:wght@500;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Raleway&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Muli:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Krub&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@1,400;1,700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500&display=swap');

.mainBody {
    padding-bottom: 0px;
}
a {
    text-decoration: none;
    color: rgb(95, 94, 94);
}
body {
    overflow-x: hidden;
    margin: 0;
    padding: 0;
    font-family: 'Open sans', sans-serif;
    font-weight: 400;
    /* min-height: 95vh; */
}

h1 {
    font-family: 'Quicksand', sans-serif;
    color: rgb(68, 68, 68);
    font-size: 2.7rem; 
}

h2 {
    font-family: 'Quicksand', sans-serif;
    color: rgb(48, 48, 48);
    font-size: 1.7rem;  
}

/* FAT TITLE TEXT */
h5 {
    font-family: 'Palanquin Dark', sans-serif
}
textarea, input {
    font-family: 'Open Sans', sans-serif;
}

/* ////////// BUTTONS \\\\\\\\\\ */
    button {
        font-family: 'Lato', sans-serif;
        font-weight: 400;
    }


/* ////////// STATUS BOXES(LABELS) \\\\\\\\\\ */
    /*DASHDEALS SINGLE DEAL STATUS */
    .dealStatus p {
        font-family: 'DM Sans', sans-serif;
    }
    /* DASHBOARD MAIN PAGE */ 
    .singleOrderStatus p {
        font-family: 'DM Sans', sans-serif;
    }
    /* SHOP PRODUCTS STATUS */
    .statusContainer p {
        font-family: 'DM Sans', sans-serif;
    }

</style>
